import { apiB2B } from '../axios-client';
import { B2B_ACCOUNT_REWARDS_AND_OFFERS_PATH } from '../../constants';
import { IRewardsAndOffers } from '../../models/b2b';
import { getTHDCustomer } from '../../utils/GeneralUtil';

const hasCredentials = (cust = getTHDCustomer()) => cust.svocID && cust.userID;

export class CredentialsMissingError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'CredentialsMissingError';
  }
}

export const accountApi = {
  rewardsAndOffersDetails: (): Promise<IRewardsAndOffers> => {
    if (!hasCredentials())
      return Promise.reject(
        new CredentialsMissingError('userID or svocID is missing'),
      );
    return apiB2B
      .get<IRewardsAndOffers>(B2B_ACCOUNT_REWARDS_AND_OFFERS_PATH)
      .then(({ data }) => data);
  },
};
